module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "baja-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("warning")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('alerta')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message')))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.eliminarCompte
    }
  }, [_vm._v(_vm._s(_vm.$t('esborrar')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55da038c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/baja-modal/baja-modal.vue
// module id = 308
// module chunks = 0